import { useState, useEffect } from "react";
import { fetchBusinessUnits } from "../services/businessUnitsService";
import type { BusinessUnitOption } from "../types/businessUnit";
import { mergeBusinessUnitOptionsFromApi } from "../utils/businessUnitApiCodes";

/** Until the API responds: synthetic “All” only (no hardcoded BU list). */
const initialOptions = (): readonly BusinessUnitOption[] => mergeBusinessUnitOptionsFromApi([]);

export const useBusinessUnits = () => {
  const [options, setOptions] = useState<readonly BusinessUnitOption[]>(initialOptions);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    fetchBusinessUnits()
      .then((data) => {
        if (!cancelled) {
          setOptions(mergeBusinessUnitOptionsFromApi(data));
        }
      })
      .catch(() => {
        if (!cancelled) {
          setOptions(mergeBusinessUnitOptionsFromApi([]));
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { options, loading };
};
